import { TipoAtendimentoProfissional } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'
import { AgendamentoDia } from 'view/atendimentos/types/AgendamentoDia'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { SoapSection } from '../SoapSection'
import { DesfechoForm, DesfechoFormModel } from './DesfechoForm'

export interface DesfechoSectionProps {
  name: MetaPath<DesfechoFormModel>
  profissionalId?: ID
  isDemandaEspontanea?: boolean
  dataAtendimento: Instant
  cidadao: CidadaoAtendimento
  agendamentosDia: AgendamentoDia[]
  tipoAtendProf: TipoAtendimentoProfissional
}

export function DesfechoSection(props: DesfechoSectionProps) {
  return (
    <SoapSection initial='D' title='Desfecho'>
      <DesfechoForm {...props} />
    </SoapSection>
  )
}
